import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/webConfig/base"

const webConfig = {
  webConfigList(pageSize, limit) {
    return axios.get(pre + `/webConfigList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,

        }
    });
  },
  webConfigInfo(id) {
    return axios.get(pre + `/webConfigInfo`, {params: {id: id}});
  },
  saveWebConfigInfo(params) {
    return axios.post(pre + `/saveWebConfigInfo`, qs.stringify(params));
  },
  deleteWebConfigInfo(id) {
    return axios.post(pre + `/deleteWebConfigInfo`, qs.stringify({id: id}));
  },
}
export default webConfig;



// WEBPACK FOOTER //
// ./src/api/config/webConfig.js